/**
 * Dependencies
 */

import mixpanel from 'mixpanel-browser';

/**
 * Define client
 */

mixpanel.init('1bbdef6d61e833714dd13e337912833b');

/**
 * Export client
 */

export default mixpanel;
